module.exports = __webpack_public_path__ + "img/peel_2.de07f32c.jpg";